module.exports = "<p>The artist on<br><em>Cape Cod Chandelier</em> 2011</p> ";


//////////////////
// WEBPACK FOOTER
// ./src/Rist/content/tourWorks/room8/audio2/content.md
// module id = 849
// module chunks = 0